// src/services/user.ts
import { db } from "./firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

interface ChildProfile {
  name: string;
  createdAt: any;
  updatedAt: any;
  preferences: {
    prefDesign: string;
    prefLanguage: string;
  };
  favorites: string[];
  remember: string[];
  likedStories: string[];
  readStories: string[];
}

/**
 * Erstellt das Haupt‑User‑Dokument und, falls noch nicht vorhanden,
 * ein Default‑Child‑Profil in der Subcollection "children".
 */
export async function createUserDocument(
  uid: string,
  email: string,
  displayName: string
) {
  const userRef = doc(db, "users", uid);
  const userSnap = await getDoc(userRef);

  // 1) Haupt‑User‑Dokument anlegen
  if (!userSnap.exists()) {
    await setDoc(userRef, {
      checkoutSessionId: "",
      counterReset: new Date("2025-01-01T00:00:01+01:00"),
      createdAt: serverTimestamp(),
      displayName,
      email,
      lastLoginAt: serverTimestamp(),
      lastPaymentDate: null,
      hasVoted: false,
      votingReset: serverTimestamp(),
      lastVote: null,
      likedStories: [],
      readStories: [],
      preferences: {
        prefDesign: "default",
        prefEmail: false,
        prefLanguage: "default",
        prefMessage: false,
      },
      reader: {
        readerDesign: "default",
        readerLanguage: "default",
        readerTextSize: "default",
        readerTextStyle: "default",
      },
      stripeCustomerId: "",
      subscription: {
        basePlan: "free",
        addOns: [],
        status: "active",
        expiry: null,
        quotas: {
          pdfReads: 20,
          audioMinutes: 0,
          videoMinutes: 0,
        },
      },
      usage: {
        pdfReadsThisMonth: 0,
        audioMinutesThisMonth: 0,
        videoMinutesThisMonth: 0,
      },
      updatedAt: serverTimestamp(),
    });
    console.log("User document created for UID:", uid);
  } else {
    console.log("User document already exists for UID:", uid);
  }

  // 2) Default‑Child‑Profil in Subcollection "children" anlegen
  const childRef = doc(db, "users", uid, "children", "default");
  const childSnap = await getDoc(childRef);
  if (!childSnap.exists()) {
    const childProfile: ChildProfile = {
      name: displayName || "Kind",
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      preferences: {
        prefDesign: "default",
        prefLanguage: "de",
      },
      favorites: [],
      remember: [],
      likedStories: [],
      readStories: [],
    };
    await setDoc(childRef, childProfile);
    console.log("Default child profile created for UID:", uid);
  } else {
    console.log("Default child profile already exists for UID:", uid);
  }
}
